const APP_URL = process.env.REACT_APP_APP_URL;
const FALLBACK_URL = process.env.REACT_APP_WEB_URL_FALLBACK2;
export default {
    generateLink(params = {}, isFallback = false) {
        let { pathname = '', search = '' } = params;
        const pageSource = sessionStorage.getItem("pageSource");
        let path = pageSource || pathname;
        let express = false;

        console.log('Original Path:', path);

        // When called from fallBackLink, modify path if needed
        if (isFallback) {
            // Parse existing search query
            const urlParams = new URLSearchParams(search.startsWith('?') ? search.substring(1) : search);

            // Check if express is true in query params
            if (urlParams.get('express') === 'true' && !path.startsWith('/express')) {
                path = `/express${path}`;
                urlParams.delete('express'); // Remove express from query params
                search = urlParams.toString();
            }
        }
        // Check if the path starts with "/express"
        else if (path.startsWith("/express")) {
            path = path.replace(/^\/express/, ''); // Remove the "/express"
            express = true;
        }

        // Get the base URL (removing trailing slash if necessary)
        const baseUrl = isFallback ? FALLBACK_URL?.replace(/\/$/, '') : APP_URL;

        // Parse existing search query
        const urlParams = new URLSearchParams(search.startsWith('?') ? search.substring(1) : search);

        // Always set the "express" query parameter
        urlParams.set("express", express);

        // Build the final URL
        const newSearch = urlParams.toString();
        const separator = newSearch ? '?' : ''; // Only add "?" if there are query parameters

        // Return the final URL with the correct query string
        return `${baseUrl}${path}${separator}${newSearch}`;
    },

    checkLink(params) {
        return this.generateLink(params, false); // Staging URL
    },
    fallBackLink(params) {
        return this.generateLink(params, true); // Fallback URL
    }

};
